<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents">Indice</p>
<p class="P_TOC_Entry_1"><a href="#/section0001#auto_bookmark_toc_1">Sinossi</a></p>
<p class="P_TOC_Entry_1"><a href="#/section0003#auto_bookmark_toc_1">Capitolo 1</a></p>
<p class="P_TOC_Entry_1"><span href="#/section0004#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 2</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0005#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 3</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0006#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 4</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0007#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 5</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0008#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 6</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 7</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 8</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 9</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0012#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 10</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0013#auto_bookmark_toc_1" title="Link target outside of Sample">Capitolo 11</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0014#auto_bookmark_toc_1" title="Link target outside of Sample">Di prossima uscita</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0016#auto_bookmark_toc_1" title="Link target outside of Sample">Altri libri di Mary Calmes</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0017#auto_bookmark_toc_1" title="Link target outside of Sample">Biografia</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0018#auto_bookmark_toc_1" title="Link target outside of Sample">Di Mary Calmes</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0019" title="Link target outside of Sample">Copyright</span></p>
<p class="P_TOC_Entry_1"><span href="#/section0020#auto_bookmark_toc_1" title="Link target outside of Sample">Pubblicato da</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?34357859